import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

const prefixUrl = "/item";

export default {
    async list(param: types.item.ReqItemList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async listForMain1(): Promise<types.item.ResItemList> {
        const res = {} as types.item.ResItemList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/listForMain1", null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async listForMain2(): Promise<types.item.ResItemList> {
        const res = {} as types.item.ResItemList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/listForMain2", null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.item.ResItem> {
        const res = {} as types.item.ResItem;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/detail/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async add(param: types.item.ReqItem): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(prefixUrl + "/add", formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(param: types.item.ReqItemForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(prefixUrl + "/modify", formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async listForHistory(idxParent: number, param: types.ReqParam): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/" + idxParent + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async addForHistory(idxParent: number, param: types.item.ReqItemHistory): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/" + idxParent + "/add", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modifyForHistory(idxParent: number, param: types.item.ReqItemHistoryForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/" + idxParent + "/modify", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async removeForHistory(idxParent: number, idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/history/" + idxParent + "/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async removeForHistoryForMultiple(idxParent: number, idxList: Array<number>): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                prefixUrl + "/history/" + idxParent + "/remove",
                { idxList: idxList.join(",") },
                { withCredentials: false },
            );

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
};
